import { envsafe, str, url } from "envsafe";

export const env = envsafe(
  {
    VITE_API_URL: url(),
    VITE_NTFY_URL: url(),
    VITE_VAPID_PUBLIC_KEY: str(),
  },
  {
    env: import.meta.env as Record<string, string | undefined>,
  },
);
